import {
  AnimateGroup,
  AnimateItem,
  AnimatePresence,
  AnimateRoot,
} from "./parts";

const Animate = Object.assign(AnimateRoot, {
  Group: AnimateGroup,
  Item: AnimateItem,
  Presence: AnimatePresence,
});

export default Animate;
